<app-top-nav></app-top-nav>

<div class="main">
  <div class="search-header">
    <input [(ngModel)]="searchValue" (keyup.enter)="executeSearch()" />
    <button (click)="executeSearch()" [disabled]="loading" mat-stroked-button>
      <mat-icon>search</mat-icon>
      <span>search</span>
    </button>
  </div>
  <div class="wrapper">
    <div class="scroll-wrapper">
      <p-table
        *ngIf="searchExecuted"
        [value]="tableData$() | async"
        [columns]="cols"
        [loading]="loading"
        id="table"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [class.col--type]="col.field == 'buildingType'"
              [class.col--suffix]="col.field == 'suffix'"
              [class.col--groupId]="
                col.field == 'buildingGroupId' ||
                col.field == 'buildingLomKey' ||
                col.field == 'addressLomKey'
              "
              [class.col--number]="col.field == 'number'"
              [class.col--mdu]="col.field == 'isMDU'"
              [class.col--engineer]="col.field == 'outsideEngineer.firstName'"
              [class.col--location]="col.field == 'location'"
              [class.status-cell]="col.field == 'surveyStatus'"
              [class.street-cell]="col.field == 'street'"
              [class.hidden]="col.hidden"
            >
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{
                          sort.direction == 1
                            ? 'sort-ascending'
                            : 'sort-descending'
                        }}"
                        *ngIf="sort.direction"
                        >straight</mat-icon
                      >
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon"
                      >filter_alt</mat-icon
                    >
                    <ng-container
                      *ngIf="getFieldFilters$(col.field) | async as filters"
                    >
                      <span *ngIf="filters" class="clear-header-filters"
                        >({{ filters.length }})</span
                      >
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
                <ng-container *ngIf="col.field == 'surveyStatus'">
                  <button
                    class="clear-button"
                    mat-flat-button
                    color="warn"
                    (click)="clearAllFilter()"
                    *ngIf="extendedFilterActive$ | async"
                  >
                    clear all
                  </button>
                </ng-container>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr>
            <td class="col--groupId">
              <app-figure
                [Color]="row.figure?.Color"
                [Figure]="row.figure?.Figure"
                style="margin: 0 !important"
              ></app-figure>
            </td>
            <td class="col--groupId" *ngIf="checkDataField('buildingLomKey')">
              {{ row.buildingLomKey || "" }}
            </td>
            <td class="col--groupId" *ngIf="checkDataField('addressLomKey')">
              <!-- addressLomKey -->
            </td>
            <td class="street-cell">{{ row.street || "" }}</td>
            <td class="col--number">{{ row.number || "" }}</td>
            <td class="col--suffix" *ngIf="checkDataField('suffix')">
              {{ row.suffix || "" }}
            </td>
            <td class="col--location">
              <span (click)="openBuildingList(row)" class="cursor-pointer link">
                <span>{{ row.areaCity || "" }} |&nbsp;</span>
                <span>{{ row.fiberHood || "" }} |&nbsp;</span>
                <span>{{ row.block || "" }}</span>
              </span>
            </td>
            <td
              class="col--engineer"
              *ngIf="checkDataField('outsideEngineer.firstName')"
            >
              {{ row.outsideEngineer?.firstName || "" }}
            </td>
            <td class="col--type">
              {{ BuildingTypeEnum[row.buildingType] || "" }}
            </td>
            <td class="col--mdu">
              <ng-container
                *ngTemplateOutlet="isMDU; context: { data: row?.isMDU }"
              ></ng-container>
            </td>
            <td class="status-cell">
              <app-survey-status
                [data]="row"
                [allSurveys]="allSearchResults"
                (startSurvey)="onStartSurvey($event)"
                (goToSurvey)="onGoToSurvey($event)"
              ></app-survey-status>
            </td>
          </tr>
          <ng-container *ngIf="!row.isCollapsed">
            <tr
              class="address-row"
              *ngFor="let row of allSearchResults | BuildingId: row.buildingId"
            >
              <td class="col--groupId"><!-- buildingGroupId --></td>
              <td class="col--groupId" *ngIf="checkDataField('buildingLomKey')">
                <!-- buildingKey -->
              </td>
              <td class="col--groupId" *ngIf="checkDataField('addressLomKey')">
                {{ row.addressLomKey || "" }}
              </td>
              <td class="street-cell">{{ row.street || "" }}</td>
              <td class="col--number">{{ row.number || "" }}</td>
              <td class="col--suffix" *ngIf="checkDataField('suffix')">
                {{ row.suffix || "" }}
              </td>
              <td class="col--location"></td>
              <td
                class="col--engineer"
                *ngIf="checkDataField('outsideEngineer.firstName')"
              >
                <!-- Engineer -->
              </td>
              <td class="col--type">
                {{ AddressTypeEnum[row.addressType] || "" }}
              </td>
              <td class="col--mdu">
                <ng-container
                  *ngTemplateOutlet="isMDU; context: { data: row?.isMDU }"
                ></ng-container>
              </td>
              <td class="status-cell"><!-- survey status --></td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- TEMPLATES -->
<ng-template #surveyStatus let-data="data">
  <app-survey-status-button
    [status]="data"
    [abbreviate]="false"
  ></app-survey-status-button>
</ng-template>
<ng-template #isMDU let-data="data">
  <mat-icon *ngIf="data" class="material-icons-outlined">check_circle</mat-icon>
</ng-template>
<ng-template #buildingGroup let-data="data">
  <app-figure
    [Color]="data?.Color"
    [Figure]="data?.Figure"
    style="margin: 0 !important"
  ></app-figure>
</ng-template>
